import { Method } from 'axios';
import { APICallV0 } from 'reactApp/api/APICall';

export class BuyBusinessAPICall extends APICallV0 {
    _baseUrl = 'https://help.mail.ru/cloud_web/';
    _method = 'forms/entity';
    _type: Method = 'post';
    _headers = { 'Content-Type': 'multipart/form-data' };
}
